// extracted by mini-css-extract-plugin
export default {"spin":"AppLoading_spin__SmU6F"};